// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosResponse, AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { asyncScheduler, Observable } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { searchOnlineCourses } from '../../../apis/onlineCourse';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';

const {
  searchOnlineCoursesActions,
} = actionCreatorsList;

const outputActions = {
  success: searchOnlineCoursesActions.success,
  failure: searchOnlineCoursesActions.failure
};

type RequestActionTypes = ActionType<
  typeof searchOnlineCoursesActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const searchOnlineCoursesEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(searchOnlineCoursesActions.request),
    ),
    throttleTime(1000, asyncScheduler, { leading: true, trailing: true }),
    switchMap((action: RequestActionTypes) => {
      const { limit, page, condition } = action.payload;

      return searchOnlineCourses(limit, page, condition)
        .then(response => {
          const { list, totalPage, count } = response.data || {};
          return searchOnlineCoursesActions.success({
            list,
            totalPage,
            page,
            limit,
            count,
          });
        })
        .catch((error: AxiosError) => {
          return searchOnlineCoursesActions.failure({ error });
        });
    }),
  );
};
